// MODULES
import RequestRabbit from './RequestRabbit';

// CONFIG
import Config from '../Config';

const useLanguageRequest = () => {
  const getLanguages = async (errorHandler) => {
    try {
      const url = `${Config.baseServerURL}/language`;
      const options = { method: 'GET' };
      const response = await RequestRabbit.request(url, options, errorHandler);

      if (response?.status >= 400 && response?.status < 600) {
        throw new Error(response?.body);
      }

      return await response?.json();
    } catch (error) {
      errorHandler(error);
    }
  };

  // Export functions as a module
  return {
    getLanguages,
  };
};
export default useLanguageRequest;
